"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _ClientForm = _interopRequireDefault(require("./components/ClientForm"));
var _apolloClient = require("@/apollo/apolloClient");
var _appUtil = require("@/utils/app-util");
var _clientQuery = require("@/apollo/queries/client-query");
var _clientMutation = require("@/apollo/mutations/client-mutation");
var _UploadFileUtil = _interopRequireDefault(require("@/views/mixin/UploadFileUtil"));
var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));
var _auth = require("@/utils/auth");
var _v = _interopRequireDefault(require("uuid/v4"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ClientForm: _ClientForm.default
  },
  mixins: [_UploadFileUtil.default, _FirebaseStorageUtil.default],
  data: function data() {
    return {
      form: {
        company_name: '',
        ceo_name: '',
        zip_code: '',
        address1: '',
        address2: '',
        phone_number: '',
        fax_number: '',
        mobile_phone: '',
        mail_address: '',
        occupation: '',
        business_content: '',
        login_id: '',
        login_password: '',
        confirmed_password: '',
        update_info: '',
        pass_check: false
      },
      form_original: {
        company_name: '',
        ceo_name: '',
        zip_code: '',
        address1: '',
        address2: '',
        phone_number: '',
        fax_number: '',
        mobile_phone: '',
        mail_address: '',
        occupation: '',
        business_content: '',
        login_id: '',
        login_password: '',
        confirmed_password: '',
        update_info: '',
        pass_check: false
      },
      showForm: {
        company_name: true,
        ceo_name: true,
        zip_code: true,
        address1: true,
        address2: true,
        phone_number: true,
        fax_number: true,
        mobile_phone: true,
        mail_address: true,
        occupation: true,
        business_content: true,
        login_id: true,
        login_password: true,
        confirmed_password: true,
        pass_check: true
      },
      submitBtnName: '更新',
      loading: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapState)({
    currentClient: function currentClient(state) {
      return state.auth.currentClient;
    }
  })),
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var client, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ((0, _auth.getUUID)()) {
              _context.next = 1;
              break;
            }
            this.$notify({
              title: 'エラー',
              message: 'リクエストエラーです',
              type: 'error',
              duration: 5000
            });
            return _context.abrupt("return", this.RecruitmentIndex());
          case 1:
            _context.next = 2;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENT_QUERY,
              variables: {
                uid: (0, _auth.getUUID)()
              },
              fetchPolicy: 'no-cache'
            }).catch(function (error) {
              console.error('error' + error);
            });
          case 2:
            client = _context.sent;
            if (client.data.client_user.length) {
              _context.next = 3;
              break;
            }
            this.$notify({
              title: 'エラー',
              message: 'リクエストエラーです',
              type: 'error',
              duration: 5000
            });
            return _context.abrupt("return", this.RecruitmentIndex());
          case 3:
            this.$data.form = client.data.client_user[0];
            this.$data.form_original.company_name = client.data.client_user[0].company_name;
            this.$data.form_original.ceo_name = client.data.client_user[0].ceo_name;
            this.$data.form_original.zip_code = client.data.client_user[0].zip_code;
            this.$data.form_original.address1 = client.data.client_user[0].address1;
            this.$data.form_original.address2 = client.data.client_user[0].address2;
            this.$data.form_original.phone_number = client.data.client_user[0].phone_number;
            this.$data.form_original.fax_number = client.data.client_user[0].fax_number;
            this.$data.form_original.mobile_phone = client.data.client_user[0].mobile_phone;
            this.$data.form_original.mail_address = client.data.client_user[0].mail_address;
            this.$data.form_original.occupation = client.data.client_user[0].occupation;
            this.$data.form_original.business_content = client.data.client_user[0].business_content;
            this.$data.form_original.login_id = client.data.client_user[0].login_id;
            this.$data.form_original.login_password = client.data.client_user[0].login_password;
            this.$data.form_original.update_info = client.data.client_user[0].update_info;
            _context.next = 4;
            return (0, _appUtil.checkReadingFlag)(true);
          case 4:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 5;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    RecruitmentIndex: function RecruitmentIndex() {
      return this.$router.push({
        name: 'RecruitmentIndex'
      });
    },
    updateClient: function () {
      var _updateClient = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, updateObjects) {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('updateClient');
              _context3.next = 1;
              return _apolloClient.apolloClient.mutate({
                mutation: _clientMutation.UPDATE_CLIENT,
                variables: {
                  uid: id,
                  objects: updateObjects
                }
              }).then(function (result) {
                _apolloClient.apolloClient.resetStore();
                console.log('updateClientResolve');
                var resultClient = result.data.update_client_user.returning[0];
                return Promise.resolve(resultClient);
              }).catch(function (error) {
                console.log('updateClientError');
                return Promise.reject(error);
              });
            case 1:
              return _context3.abrupt("return", _context3.sent);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function updateClient(_x, _x2) {
        return _updateClient.apply(this, arguments);
      }
      return updateClient;
    }(),
    checkUpdateFlag: function () {
      var _checkUpdateFlag = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(updateFlag) {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(updateFlag.company_name === true)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return", true);
            case 1:
              if (!(updateFlag.ceo_name === true)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", true);
            case 2:
              if (!(updateFlag.zip_code === true)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", true);
            case 3:
              if (!(updateFlag.address1 === true)) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return", true);
            case 4:
              if (!(updateFlag.address2 === true)) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", true);
            case 5:
              if (!(updateFlag.phone_number === true)) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", true);
            case 6:
              if (!(updateFlag.fax_number === true)) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return", true);
            case 7:
              if (!(updateFlag.mobile_phone === true)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", true);
            case 8:
              if (!(updateFlag.mail_address === true)) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", true);
            case 9:
              if (!(updateFlag.occupation === true)) {
                _context4.next = 10;
                break;
              }
              return _context4.abrupt("return", true);
            case 10:
              if (!(updateFlag.business_content === true)) {
                _context4.next = 11;
                break;
              }
              return _context4.abrupt("return", true);
            case 11:
              if (!(updateFlag.login_password === true)) {
                _context4.next = 12;
                break;
              }
              return _context4.abrupt("return", true);
            case 12:
              return _context4.abrupt("return", false);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function checkUpdateFlag(_x3) {
        return _checkUpdateFlag.apply(this, arguments);
      }
      return checkUpdateFlag;
    }(),
    postFormSubmit: function () {
      var _postFormSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(form) {
        var _this = this;
        var pwd, updateObjects, update_info, update, _t3, _t4;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.loading = true;
              pwd = null;
              if (this.$data.form.pass_check === true) {
                pwd = (0, _appUtil.makePasswordHash)(this.$data.form.login_password);
              }
              update_info = {
                company_name: false,
                ceo_name: false,
                zip_code: false,
                address1: false,
                address2: false,
                phone_number: false,
                fax_number: false,
                mobile_phone: false,
                mail_address: false,
                occupation: false,
                business_content: false,
                login_password: false
              };
              if (!(this.$data.form.update_info === null || this.$data.form.update_info === '')) {
                update_info = JSON.parse(this.$data.form.update_info);
              }
              if (this.$data.form.company_name !== this.$data.form_original.company_name) {
                update_info.company_name = true;
              }
              if (this.$data.form.ceo_name !== this.$data.form_original.ceo_name) {
                update_info.ceo_name = true;
              }
              if (this.$data.form.zip_code !== this.$data.form_original.zip_code) {
                update_info.zip_code = true;
              }
              if (this.$data.form.address1 !== this.$data.form_original.address1) {
                update_info.address1 = true;
              }
              if (this.$data.form.address2 !== this.$data.form_original.address2) {
                update_info.address2 = true;
              }
              if (this.$data.form.phone_number !== this.$data.form_original.phone_number) {
                update_info.phone_number = true;
              }
              if (this.$data.form.fax_number !== this.$data.form_original.fax_number) {
                update_info.fax_number = true;
              }
              if (this.$data.form.mobile_phone !== this.$data.form_original.mobile_phone) {
                update_info.mobile_phone = true;
              }
              if (this.$data.form.mail_address !== this.$data.form_original.mail_address) {
                update_info.mail_address = true;
              }
              if (this.$data.form.occupation !== this.$data.form_original.occupation) {
                update_info.occupation = true;
              }
              if (this.$data.form.business_content !== this.$data.form_original.business_content) {
                update_info.business_content = true;
              }
              if (pwd !== null) {
                update_info.login_password = true;
              }
              this.$data.form_original.company_name = this.$data.form.company_name;
              this.$data.form_original.ceo_name = this.$data.form.ceo_name;
              this.$data.form_original.zip_code = this.$data.form.zip_code;
              this.$data.form_original.address1 = this.$data.form.address1;
              this.$data.form_original.address2 = this.$data.form.address2;
              this.$data.form_original.phone_number = this.$data.form.phone_number;
              this.$data.form_original.fax_number = this.$data.form.fax_number;
              this.$data.form_original.mobile_phone = this.$data.form.mobile_phone;
              this.$data.form_original.mail_address = this.$data.form.mail_address;
              this.$data.form_original.occupation = this.$data.form.occupation;
              this.$data.form_original.business_content = this.$data.form.business_content;
              update = null;
              if (!(pwd === null)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 1;
              return this.checkUpdateFlag(update_info);
            case 1:
              _t3 = _context5.sent;
              if (!(_t3 === true)) {
                _context5.next = 2;
                break;
              }
              update = JSON.stringify(update_info);
            case 2:
              updateObjects = {
                company_name: this.$data.form.company_name,
                ceo_name: this.$data.form.ceo_name,
                zip_code: this.$data.form.zip_code,
                address1: this.$data.form.address1,
                address2: this.$data.form.address2,
                phone_number: this.$data.form.phone_number,
                fax_number: this.$data.form.fax_number,
                mobile_phone: this.$data.form.mobile_phone,
                mail_address: this.$data.form.mail_address,
                occupation: this.$data.form.occupation,
                business_content: this.$data.form.business_content,
                update_info: update
              };
              _context5.next = 6;
              break;
            case 3:
              _context5.next = 4;
              return this.checkUpdateFlag(update_info);
            case 4:
              _t4 = _context5.sent;
              if (!(_t4 === true)) {
                _context5.next = 5;
                break;
              }
              update = JSON.stringify(update_info);
            case 5:
              updateObjects = {
                company_name: this.$data.form.company_name,
                ceo_name: this.$data.form.ceo_name,
                zip_code: this.$data.form.zip_code,
                address1: this.$data.form.address1,
                address2: this.$data.form.address2,
                phone_number: this.$data.form.phone_number,
                fax_number: this.$data.form.fax_number,
                mobile_phone: this.$data.form.mobile_phone,
                mail_address: this.$data.form.mail_address,
                occupation: this.$data.form.occupation,
                business_content: this.$data.form.business_content,
                login_password: pwd,
                update_info: update
              };
            case 6:
              _context5.next = 7;
              return this.updateClient((0, _auth.getUUID)(), updateObjects).then(function (resultClient) {
                console.log(resultClient);
                return Promise.resolve(resultClient);
              }).then(function (result) {
                _this.loading = false;
                _this.$notify({
                  title: '成功',
                  message: 'アカウント情報を更新しました。',
                  type: 'success',
                  duration: 5000
                });
              }).catch(function (error) {
                console.log(error);
                _this.loading = false;
                _this.$notify({
                  title: '失敗',
                  message: 'アカウント情報を更新できませんでした。',
                  type: 'error',
                  duration: 5000
                });
              });
            case 7:
              return _context5.abrupt("return", _context5.sent);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function postFormSubmit(_x4) {
        return _postFormSubmit.apply(this, arguments);
      }
      return postFormSubmit;
    }()
  }
};